import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { lazy as loadable } from '@loadable/component'

import { SSRNavigate } from '@newComponents/SSRNavigate'
import { wrapSuspenseComponent } from '@newComponents/SuspenseWrapper'

import { DocsSection } from '../shared/DocsSection'

const OAuth = wrapSuspenseComponent(loadable(() => import('./OAuth')))

const DevelopersSection = () => (
  <DocsSection section='developers'>
    <Routes>
      <Route index element={<SSRNavigate to='oauth' replace />} />
      <Route path='oauth' element={<OAuth />} />
    </Routes>
  </DocsSection>
)

export default DevelopersSection
